<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">代理商充值</h1>
            <el-form class="form-container" :model="factorInfo" :rules="factorRules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">当前费用状态</span>
                    </div>
                    <div class="form-input-item">
                        {{factorInfo.fee_status_string}}
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">当前余额</span>
                    </div>
                    <div class="form-input-item">
                        {{factorInfo.balance_string}}
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">充值金额</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="amount">
                            <el-input placeholder="请输入充值金额"  v-model="factorInfo.amount">
                                <div slot="append">
                                    元
                                </div>
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">充值方式</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="recharge_type">
                            <el-select v-model="factorInfo.recharge_type" placeholder="请选择充值方式">
                                <el-option v-for="item in options" :key="item.id" :label="item.value" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">保 存</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import {recharge}  from '@/service/payment'
    import {validateNumber} from  '@/utils/validate'
    export default {
        name: "recharge",
        components: {
            PopoverRight
        },
        props: {
            callback: Function
        },
        methods : {
            open (row) {
                if (row) {
                    this.factorInfo = Object.assign({}, this.factorInfo, row)
                }
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.resetForm()
            },
            resetForm () {
                this.factorInfo = {
                    id : 0,
                    name: '',
                    fee_status_string: '',
                    balance_string: '',
                    amount:'',
                    recharge_type:'1'
                }
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let query = {
                            amount:parseInt(this.factorInfo.amount),
                            recharge_type:this.factorInfo.recharge_type,
                        }
                        recharge(this.factorInfo.id, query).then((data) => {
                            this.$message({
                                message: '充值成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback();
                        }).catch(err => {
                            this.$message({
                                message: err.message || '充值失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    } else {
                        return false
                    }
                })
            },
        },
        data () {
            const amountValidate = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入充值金额'))
                } else if (!/^([\+ \-]?(([1-9]\d*)|(0)))?$/.test(value) || parseFloat(value) >= 100000 ||  parseFloat(value) <= -100000) {
                    callback(new Error('充值金额为-100000-100000之间的数字'))
                }else {
                    callback()
                }
            }
            return {
                options: [
                    { id: '1', value: '用户充值'},
                    { id: '2', value: '总部赠送'}
                ],
                factorInfo: {
                    id : 0,
                    name: '',
                    fee_status_string: '',
                    balance_string: '',
                    amount:'',
                    recharge_type: '1'
                },
                factorRules: {
                    amount: [
                        { trigger: 'blur', validator:amountValidate }
                    ],
                    recharge_type: [
                        { required: true, message: '请选择充值类型', trigger: 'blur' }
                    ],
                },

            }
        }
    }
</script>

<style scoped>

</style>
